/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getFeInvoicePayments,
    getFeInvoicePayment,
    printFeInvoicePayment,
    createFeInvoicePayments,
    updateFeInvoicePayments,
    deleteFeInvoicePayments,
} from "Modules/sales/fe_invoices/config/api.fe_invoice_payments";

const state = {
    page: {},
    form: {},
    fe_invoice_payments: [],
    fe_invoice_payment_options: [],
    selectedFeInvoicePayment: {
        payment_id: null,
        company_id: "",
        fe_invoice_payment_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        fe_invoice_payment_details: [],
    },
    fe_invoice_payments_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_fe_invoice_payments: {
        payment_id: {
            name: "payment_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        invoice_id: {
            name: "invoice_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        payment_date: {
            name: "payment_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        due_date: {
            name: "due_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "18",
            min_len: "",
            default_value: "1.000000",
        },
        account_id: {
            name: "account_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        notes: {
            name: "notes",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        amount: {
            name: "amount",
            rules: "trim|max_length[13]|decimal",
            max_len: "13",
            min_len: "",
            default_value: "1.000",
        },
    },
};

// getters
const getters = {
    fe_invoice_payments: (state) => {
        return state.fe_invoice_payments;
    },
};

// actions
const actions = {
    async fetchFeInvoicePayments({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getFeInvoicePayments({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "fe_invoice_payment_options",
                        with: response.data.fe_invoice_payments,
                    });
                } else {
                    commit("mutate", {
                        property: "fe_invoice_payments",
                        with: response.data.fe_invoice_payments,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchFeInvoicePayment({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getFeInvoicePayment(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedFeInvoicePayment",
                    with: response.data.fe_invoice_payment,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printFeInvoicePayment({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printFeInvoicePayment(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveFeInvoicePayment({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["payment_id"] === "undefined" || body["payment_id"] == null || body["payment_id"] == "") {
                delete body["payment_id"];
                response = await createFeInvoicePayments({ body: body, headers: config.headers });
            } else {
                let payment_id = body["payment_id"];
                delete body["payment_id"];
                response = await updateFeInvoicePayments({ body: body, headers: config.headers }, payment_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteFeInvoicePayment({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteFeInvoicePayments(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    resetFeInvoicePayments(state) {
        // take the state values and set them back to default except for the rules_
        state.page = {};
        state.form = {};
        state.fe_invoice_payments = [];
        state.fe_invoice_payment_options = [];
        state.selectedFeInvoicePayment = {
            payment_id: null,
            company_id: "",
            fe_invoice_payment_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            fe_invoice_payment_details: [],
        };
        state.fe_invoice_payments_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
